import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://holeorqqhnfgtfnsftro.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhvbGVvcnFxaG5mZ3RmbnNmdHJvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ0NzcyNzMsImV4cCI6MjA5MDA1MzI3M30.3z_z6cWf_1aDA3IPtUv0duTTMF-uUOXl3OtCYpBOJB0'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})